export const TransactionState = {
  WAITING_TO_START: 'waiting_to_start',
  ENTER_CARD_DETAILS: 'enter_card_details',
  IN_PROGRESS: 'in_progress',
  CANCEL_FROM_TERMINAL: 'cancel_from_terminal',
  CANCELED: 'transaction_canceled',
  DECLINED: 'transaction_declined',
  FAILED: 'transaction_failed',
  COMPLETE: 'transaction_complete',
  ERROR: 'transaction_error',
};

export const PaymentMethod = {
  MANUAL_POS: 'manual',
  MANUAL_TERMINAL: 'manual_terminal',
};

export const CTS_CONTAINER_ID = 'manualCreditContainer';
